export default function baseRoute(route, guards = null) {
  if (guards) {
    if (Array.isArray(guards)) {
      route.beforeEnter = (to, from, next) => chainGuards(to, from, next, guards);
    } else {
      route.beforeEnter = guards;
    }
  }

  return route;
}

function chainGuards(to, from, next, guards) {
  for (let guard of guards) {
    guard(to, from, next);
  }
}
